<template>
  <a-modal v-model="visible" :confirm-loading="submitLoading" class="batch_dialog" :body-style="{padding:0}" title="重新提交排线" :after-close="afterClose" @ok="handleOk">
    <a-alert :message="`将编辑后的${form.planInfoList.length||0}条数据，合并后统一排线`" type="info" show-icon />
    <a-form-model
      ref="formRef"
      name="dynamic_form_nest_item"
      :model="form"
      :colon="false"
      :destroy-on-close="true"
     >
        <!-- <a-form-model-item prop="planMethod" label="排线规则">
          <a-radio-group v-model="form.planMethod" class="item-content" :options="PLAN_METHOD"></a-radio-group>
        </a-form-model-item> -->
        <a-form-model-item prop="planType" label="排线方式">
          <a-radio-group v-model="form.createNewPlan" class="item-content" :options="planTypeOption"></a-radio-group>
        </a-form-model-item>
      </a-form-model>
  </a-modal>
</template>

<script>
import {formatData} from '@/utils/util'
import {PLAN_METHOD,} from '../../smartWiring/list/const'
import {PLAN_TYPE} from '../const'
import {planMsgCreate} from '../api'

  export default {
    name:'SubmitDialog',
    data(){
      return{
        PLAN_METHOD,
        PLAN_TYPE,
        visible:false,
        form:{
          planInfoList:[]
        },
        planinfo:{},
        submitLoading:false
      }
    },
    computed:{
      planTypeOption(){
         return formatData(PLAN_TYPE)
      }
    },
    methods:{
      show(form,planinfo){
        this.planinfo=planinfo
        this.form={
          planInfoList:[...form],
          planMethod:planinfo.planMethod,
          createNewPlan:'CREATED'
        }
        this.visible=true
      },
      async handleOk() {
        this.submitLoading=true
        const {customerCode,realName,accountName,mobile}=this.$store.state.user
        const {createNewPlan,...restParams}=this.form
        const data={
          ...restParams,
          createNewPlan:createNewPlan==='CREATED',
          customerCode,
          realName,
          accountName,
          mobile
        }
        if(!data.createNewPlan){
          data.planCode=this.planinfo.planCode
        }
        try {
          await planMsgCreate({...data})
          this.$message.success('提交成功')
          this.visible = false;
          this.submitLoading=false
          this.$router.push({
            path:'/smartWiring',
          })
        } catch (error) {
          this.submitLoading=false
        }
      },
      afterClose(){
        this.form={
          planInfoList:[]
        }
      },
      
    }
  }
</script>

<style lang="less" scoped>
.ant-form{
  padding: 24px;
  /deep/.ant-form-item-no-colon{
    font-size: 18px !important;
    color: #333232 !important;
    font-weight:500 !important;
  }
}
.item-content{
  display: flex;
  /deep/.ant-radio-wrapper{
    display: flex !important;
    align-items: center !important;
  }
}
.ant-alert-info{
  background-color: #D9E9FC;
  border: 0;
  /deep/.ant-alert-message{
    color: #2A7CD6;
  }
  /deep/.ant-alert-icon{
    color: #2A7CD6;
  }
}
</style>